/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentReadyMessage } from '../../models/agent-ready-message';

export interface GetsessionAgentReadySchema$Params {
}

export function getsessionAgentReadySchema(http: HttpClient, rootUrl: string, params?: GetsessionAgentReadySchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentReadyMessage>> {
  const rb = new RequestBuilder(rootUrl, getsessionAgentReadySchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentReadyMessage>;
    })
  );
}

getsessionAgentReadySchema.PATH = '/api/hubs/session/AgentReady';
